<template>
  <div>
    <fg-input>
      <label class="form-label">{{ label || "Zeitraum" }}</label>
      <el-date-picker
        type="daterange"
        range-separator="bis"
        start-placeholder="Start"
        end-placeholder="Ende"
        value-format="yyyy-MM-dd"
        format="dd.MM.yyyy"
        :value="realValue"
        @input="emitFilter"
      >
      </el-date-picker>
    </fg-input>
  </div>
</template>

<script lang="babel">
import { DatePicker } from 'element-ui';
import { FgInput } from "src/components/UIComponents";

export default {
    components: {
      [DatePicker.name]: DatePicker,
      [FgInput.name]: FgInput,
    },
    props: ['value', 'attributes', 'id', 'label'],
    data () {
      return {
        lastEmittedValue: undefined,
      };
    },
    computed: {
      realValue() {
        if (!this.value) {
          return null;
        }
        let value = [];

        this.value.forEach(attribute => {
          value.push(attribute.value);
        });

        return value;
      }
    },
    methods: {
      emitFilter(dateRange) {
        // Avoid emitting null multiple times
        if (this.lastEmittedValue === dateRange) {
          return;
        }
        this.lastEmittedValue = dateRange;

        let filter = { name: 'in_out_performance', id: this.id };
        if (dateRange) {
            filter.attributes = [
              { value: dateRange[0] },
              { value: dateRange[1] }
          ]
        }
        this.$emit('filter-change', filter);
      }
    }
};
</script>
